import store from '@/store'

export default {
  /**
   * Reset store
   */
  store () {
    store.commit('user/logout')
  }
}
